import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Optional, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProvidesThemeColor } from '../../../../helpers/browser-theme/provides-theme-color';
import { BrowserThemeService } from '../../../../helpers/browser-theme/browser-theme.service';

@Component({
  selector: 'evsb-modal-header',
  templateUrl: './modal-header.component.html',
})
export class ModalHeaderComponent implements AfterViewInit, ProvidesThemeColor {
  @Input()
  public dismissible = true;
  @Input()
  public backLabel: string;
  @Input()
  public backEnabled = false;

  @Output()
  public back = new EventEmitter();
  @Output()
  public dismiss = new EventEmitter();

  @ViewChild('modalheader')
  private headerElement: ElementRef;

  constructor(@Optional() private modal: NgbActiveModal, private theme: BrowserThemeService) {}

  public ngAfterViewInit() {
    this.theme.setThemeColorFrom(this);
  }

  public get desiredThemeColor(): string {
    const style = getComputedStyle(this.headerElement.nativeElement);
    return style.backgroundColor;
  }

  public get canGoBack(): boolean {
    return this.backLabel?.length > 1;
  }

  public close() {
    if (!this.dismissible) {
      return;
    }
    this.theme.restoreOriginalThemeColor();
    if (this.dismiss.length) {
      return this.dismiss.emit(this);
    }
    this.modal?.close();
  }
}
